import styled from "styled-components";
import { handleColor, handleSize } from "../../Utilities/Icons";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { prop, theme } from "styled-tools";

export const IconStyled = styled.div<{
  size: string;
  color: string;
  gradient?: boolean;
  $fill: boolean;
  margin?: string;
  colorMobile?: string;
}>`
  width: ${(props) => handleSize(props.size)};
  height: ${(props) => handleSize(props.size)};
  margin: ${prop("margin")};

  & svg {
    width: ${(props) => handleSize(props.size)};
    height: ${(props) => handleSize(props.size)};
  }

  & path {
    stroke: ${(props) =>
      props.$fill ? theme("Dark_Silver") : handleColor(props.color)};
  }

  ${mediaQuery[Screen.xs]} {
    display: flex;
    align-items: center;

    & path {
      stroke: ${(props) =>
        props.colorMobile ? handleColor(props.colorMobile) : ""};
    }
  }

  ${mediaQuery[Screen.sm]} {
    display: flex;
    align-items: center;

    & path {
      stroke: ${(props) =>
        props.colorMobile ? handleColor(props.colorMobile) : ""};
    }
  }

  ${mediaQuery[Screen.md]} {
    display: flex;
    align-items: center;

    & path {
      stroke: ${(props) =>
        props.colorMobile ? handleColor(props.colorMobile) : ""};
    }
  }
`;
